// API sends mobile numbers as numbers without the leading zero (9121234567)
const mobile = (n) => (n ? `0${n}` : "");

// maps QueryCOPurchaseDocumentInfo Result to the `print` shape CWPrint already renders
export const fromDocumentInfo = (r) => {
	const buyer = r?.newOwner ?? {};
	const seller = r?.oldOwner ?? {};
	return {
		documentDateShamsi: r?.operationDateShamsi,
		prefactor: { iccid: r?.newICCID ?? r?.oldICCID },
		buyer: {
			profile: {
				fname: buyer.firstName,
				lname: buyer.lastName,
				certno: buyer.certNo,
				fathername: buyer.fatherName,
				birthDateShamsi: buyer.birthDateShamsi,
				postalcode: buyer.address?.postalCode,
				txtProvince: buyer.address?.provinceName,
				txtCity: buyer.address?.cityName,
				fullAddress: buyer.address?.fullAddress ?? "",
				smsmobileno: mobile(buyer.smsMobileNo),
			},
		},
		seller: {
			msisdn: mobile(r?.msisdn),
			smsmobile: mobile(seller.smsMobileNo),
			profile: {
				stR_FName: seller.firstName,
				stR_LName: seller.lastName,
				stR_CertNo: seller.certNo,
				stR_FatherName: seller.fatherName,
				birthDateShamsi: seller.birthDateShamsi,
				fullAddress: seller.address?.fullAddress ?? "",
				address: { stR_PostalCode: seller.address?.postalCode },
				province: { stR_ProvinceName: seller.address?.provinceName },
				city: { stR_CityName: seller.address?.cityName },
			},
		},
	};
};
